import { Button, Input, Select } from "@fluentui/react-components";
import { VAULT_TRANSCRIPT_CHOICES } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.constants";
import { VaultTranscriptFilter } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.types";
import { useVaultMeetingsFilterBandStyles } from "./VaultMeetingsFilterBand.styles";
import { IVaultMeetingsFilterBandProps } from "./VaultMeetingsFilterBand.types";

export const VaultMeetingsFilterBand = ({
  id,
  filters,
  shownCount,
  weekCount,
  onChange,
  onClear,
}: IVaultMeetingsFilterBandProps): JSX.Element => {
  const styles = useVaultMeetingsFilterBandStyles();

  return (
    <div
      className={styles.root}
      id={id}
      role="group"
      aria-label="Filter meetings"
    >
      <span className={styles.label} aria-hidden="true">
        Filter meetings
      </span>
      <Input
        className={styles.titleInput}
        value={filters.titleText}
        placeholder="Title contains…"
        aria-label="Title contains"
        onChange={(_, data) => onChange({ ...filters, titleText: data.value })}
      />
      <Select
        aria-label="Transcript status"
        value={filters.transcriptStatus}
        onChange={(_, data) =>
          onChange({
            ...filters,
            transcriptStatus: data.value as VaultTranscriptFilter,
          })
        }
      >
        {VAULT_TRANSCRIPT_CHOICES.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
      <Button
        appearance="transparent"
        className={styles.clearButton}
        onClick={onClear}
      >
        Clear
      </Button>
      <span className={styles.spacer} />
      <span className={styles.count}>
        Showing {shownCount} of {weekCount}
      </span>
    </div>
  );
};
